import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './cn-theme.css';
import './bb-theme.css';
import App from './App';
import CnWidget from 'npo/pages/CnWidget';
import BbWidget from 'npo/pages/BbWidget';
import { POST_HOG_HOST, POST_HOG_TOKEN } from 'shared/utils/constants';
import { isBbUserView, isCnUserView } from 'shared/utils/partnerUser';
import { PostHogProvider } from '@posthog/react';
import type { PostHogConfig } from 'posthog-js';

declare global {
  interface Window {
    isDebug?: boolean;
  }
}

// Apply partner themes immediately to prevent flash of TI colors before React mounts
const isBbPartner = isBbUserView();
const root = document.getElementById('root');
if (root && isCnUserView() && !isBbPartner) {
  root.classList.add('cnTheme');
}
if (root && (isBbPartner || window.location.pathname.startsWith('/bb-widget'))) {
  root.classList.add('bbTheme');
}

const options: Partial<PostHogConfig> = {
  api_host: POST_HOG_HOST,
};

// Render CnWidget/BbWidget directly without authentication if on widget routes
const isCnWidget = window.location.pathname.startsWith('/cn-widget');
const isBbWidget = window.location.pathname.startsWith('/bb-widget');
const app = isCnWidget ? <CnWidget /> : isBbWidget ? <BbWidget /> : <App />;
const rootComponent =
  POST_HOG_HOST && POST_HOG_TOKEN ? (
    <StrictMode>
      <PostHogProvider apiKey={POST_HOG_TOKEN} options={options}>
        {app}
      </PostHogProvider>
    </StrictMode>
  ) : (
    app
  );

if (root) {
  ReactDOM.render(rootComponent, root);
}
